const removeFormat = (key, str) => {
  if (key === "h")
    return str
      .replace("hh:", "")
      .replace("hh", "")
      .replace(/^:*/, "")
      .replace(/:\s*$/, "");

  if (key === "m")
    return str
      .replace("mm:", "")
      .replace("mm", "")
      .replace(/^:*/, "")
      .replace(/:m*$/, "");
};

function parseFormatString(formatString) {
  let obj = {};
  const regex = /([yMdhms])\s*(_{1,2})/g;
  let match;
  while ((match = regex.exec(formatString)) !== null) {
    const letter = match[1];
    const underscores = match[2];
    obj[letter] = underscores.length === 1 ? "short" : "long";
  }

  return obj;
}
export { removeFormat, parseFormatString };
